
<div class="element-selector">
  <div class="element-grid">
    <div
      v-for="item in dragItems"
      :key="item.id"
      class="element-item"
      :class="{ disabled: isLoading }"
      @click="!isLoading && selectElement(item)"
    >
      <div class="element-icon">
        <cvt-icon :icon="item.icon" />
      </div>
      <div class="element-label">{{ item.label }}</div>
    </div>
  </div>
</div>
